<template>
  <v-content
    :class="backgroundClassName"
  >
    <div id="core-view">
      <v-fade-transition mode="out-in">
        <router-view class="ma-0 pa-0" />
      </v-fade-transition>
    </div>
    <core-footer />
  </v-content>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: 'WorkTools'
    }
  },
  computed: {
    backgroundClassName () {
      let pathSplitted = this.$route.fullPath.split('?')[0].split('/')
      let home = 'home'
      let currentEnvironment = home
      if (pathSplitted.length > 1) {
        currentEnvironment = pathSplitted[1] === '' || !pathSplitted[1] ? home : pathSplitted[1]
      }

      return 'global-background-' + currentEnvironment
    }
  }
}
</script>

<style>
#core-view {
  padding-bottom: 100px;
  height: 100%
}
  .global-background-home,
  .global-background-login {
    background:
      linear-gradient(
        rgba(255, 255, 255, 0.5),
        rgba(255, 255, 255, 0.5)
      ), url(/img/background.jpg) center center;
    background-size: cover;
  }
</style>
